import { AuthService, AuthSuccessGrant, SignupUserType } from '@src/utils/cheggAuth'
import { createAction, createStandardAction } from 'typesafe-actions'
import { SchoolType } from '../analytics/rsw/eventSchemas'
import { AuthState, SetParsedJwtPayload, WritingToolsJWT } from './types'
import { InitialView } from '@chegg/one-auth'

export const VIEW_AUTH_SIGN_IN_MODE = 'VIEW_AUTH_SIGN_IN_MODE'
export const VIEW_AUTH_SIGN_UP_MODE = 'VIEW_AUTH_SIGN_UP_MODE'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SET_SELECTED_USER_TYPE = 'SET_SELECTED_USER_TYPE'
export const SET_SELECTED_SCHOOL_TYPE = 'SET_SELECTED_SCHOOL_TYPE'
export const START_AUTH_FLOW = 'START_AUTH_FLOW'

export interface AuthSuccessPayload {
  authService: AuthService
}

export interface UserSignupRole {
  memberRole: SignupUserType
}

export interface UserSignupSchool {
  schoolType: SchoolType
}

export interface LogoutMeta {
  isUserAction?: boolean
}

export const setSuccessRedirect = createStandardAction('auth/SET_SUCCESS_REDIRECT')<
  Pick<AuthState, 'successRedirect'>
>()

export const logout = createAction('auth/LOGOUT', resolve => {
  return (meta: LogoutMeta) => resolve(undefined, meta)
})

export const loadCheggAuth = createAction('auth/LOAD_CHEGG_AUTH')

export const LOGIN = 'login'
export const SIGNUP = 'signup'

export interface ShowCheggAuthExperience {
  experience: typeof LOGIN | typeof SIGNUP
  origin?: string
  title?: string
}

export interface AuthPayload {
  view?: InitialView
  origin?: string
}

export const showCheggAuthModal = createStandardAction('auth/SHOW_AUTH_MODAL')<
  ShowCheggAuthExperience
>()

export const hideCheggAuthModal = createAction('auth/HIDE_AUTH_MODAL')

export const authFlowComplete = createAction('auth/AUTH_FLOW_COMPLETE')

export const cheggAuthLoaded = createAction('auth/CHEGG_AUTH_LOADED')

export const initToken = createAction('auth/INIT_TOKEN_REQUEST')

export const cfeLogin = createStandardAction('auth/CFE_LOGIN')<AuthSuccessGrant>()

export interface FreshToken {
  jwt: string
  loginAuthType?: string
  parsedJwt?: WritingToolsJWT
}

export const handleFreshToken = createStandardAction('auth/HANDLE_FRESH_TOKEN').map(
  ({ jwt, loginAuthType }: FreshToken) => ({
    payload: { jwt, loginAuthType },
    meta: { loginAuthType },
  })
)

export interface LoggedInStateBeforeCorruption {
  wasLoggedIn: boolean
}

export const handleCorruptToken = createStandardAction('auth/HANDLE_CORRUPT_TOKEN')<
  LoggedInStateBeforeCorruption
>()

export const setParsedJwt = createStandardAction('auth/SET_PARSED_JWT')<
  SetParsedJwtPayload
>()

/**
 * This saves the data entered by a user
 * at the time of signing up to the app state.
 * This is needed later for firing events after
 * successful signup
 */
export const setSelectedUserSignUpType = createStandardAction(SET_SELECTED_USER_TYPE)<
  UserSignupRole
>()

export const setSelectedUserSchoolType = createStandardAction(SET_SELECTED_SCHOOL_TYPE)<
  UserSignupSchool
>()

export const handleSignInSuccess = createStandardAction(SIGN_IN_SUCCESS)<
  AuthSuccessPayload
>()

export const handleSignUpSuccess = createStandardAction(SIGN_UP_SUCCESS)<
  AuthSuccessPayload
>()

export const viewAuthSignInMode = () => createAction(VIEW_AUTH_SIGN_IN_MODE)()

export const viewAuthSignUpMode = () => createAction(VIEW_AUTH_SIGN_UP_MODE)()

export const startAuthFlow = createStandardAction(START_AUTH_FLOW)<AuthPayload>()



// WEBPACK FOOTER //
// ./src/state/auth/actions.ts